import { COLLECTIONS_TOGGLE_IS_OPEN_COLLECTION_CREATE_WITH_CSV } from './constants';

export function toggleIsOpenCollectionCreateWithCsv() {
  return {
    type: COLLECTIONS_TOGGLE_IS_OPEN_COLLECTION_CREATE_WITH_CSV,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_TOGGLE_IS_OPEN_COLLECTION_CREATE_WITH_CSV:
      return {
        ...state,
        isOpenCollectionCreateWithCsv: !state.isOpenCollectionCreateWithCsv,
      };

    default:
      return state;
  }
}
